module.exports = __webpack_public_path__ + "static/img/game-icon2.f47f21c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/game-icon2.png
// module id = ho67
// module chunks = 0